import React, { ReactNode } from "react";

import "app/layout/PageBase/style.scss";
import "./style.scss";
import { HeadWidgets } from "app/layout/HeadWidgets/Head";
import { LinkContextProvider } from "app/links/linkContext";
import { SizeObserveMode, SizeObserver } from "app/widgets/SizeObserver";

interface Props {
    children: ReactNode;
}

/**
 * This component provides a basic page setup.
 * It will load the Roboto font in the head and places all children inside a
 * div container with the class "page" to provide layout.
 */
export const WidgetPage = ({ children }: Props) => {
    return (
        <React.Fragment>
            <HeadWidgets />
            <LinkContextProvider target="_top">
                <SizeObserver className={"widgetPage"} mode={SizeObserveMode.BASE}>
                    {children}
                </SizeObserver>
            </LinkContextProvider>
        </React.Fragment>
    );
};
